export class StructureModelProperty {
    /**
     * The cim level is optional as pim or data-psm level may not have an
     * interpretation.
     * @deprecated use {@link iris} instead
     */
    cimIri = null;
    iris = null;
    /**
     * If the property is a container, this will represent the type of the container,
     * it will have single data type with "abstract" class with content of the container.
     *
     * Used mainly for XML xs:sequence and xs:choice.
     */
    propertyAsContainer = false;
    /**
     * The pim level is optional is data-psm level may not have an interpretation.
     */
    pimIri = null;
    /**
     * The psm level entity.
     */
    psmIri = null;
    /**
     * Label used by a computer, can be used as for example as a name of
     * a property in JSON.
     */
    technicalLabel = null;
    /**
     * Label visible to a human reader.
     */
    humanLabel = null;
    /**
     * Description visible to a human reader.
     */
    humanDescription = null;
    /**
     * Indicates that the association is oriented and reversed. The title and
     * the description may be incorrect because they may describe the forward
     * direction if there is no title and description for the reverse direction.
     */
    isReverse = null;
    cardinalityMin = null;
    cardinalityMax = null;
    dataTypes = [];
    /**
     * Whether the property was wrapped in OR
     */
    isInOr = false;
    /**
     * Whether the property, which is local is referencing an object. This is used
     * as API workaround when there is OR as a referenced root.
     */
    isReferencing = false;
    /**
     * Technical label of the wrapping OR. If the OR is not wrapped, then it is empty.
     */
    orTechnicalLabel = null;
    /**
     * If true the output is not materialized.
     */
    dematerialize = null;
    /**
     * If this property is not on it's PSM owner class, this store
     * path from the original location to the current owner. This can happen
     * for by dematerialization. The first item is the original owner class.
     */
    pathToOrigin = [];
    /**
     * Because the structure property belongs to one object, this represents the path in semantic graph model from the object to this property.
     * The path does not contain the object itself.
     * Examples:
     *  - only the property if it belongs directly to the class
     *  - path to parent class and then the property if the property belongs to the parent class
     */
    semanticPath = null;
    /**
     * Whether this property should be treated as attribute in XML.
     */
    xmlIsAttribute = false;
}
//# sourceMappingURL=structure-model-property.js.map